<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <div>
      <div>
        <b-row>
            <b-col cols="8" style="text-align: left">
                <p class="m-0" style="font-size: 1.1em; color: #063553; font-weight: 600">
                {{ empresaActual.nombrePlan }}
                </p>
                <div>
                    <p class="m-0" style="color: #063553;" v-if="vigenciasPlan.idVigenciaSeleccionada == 1">Vigencia: {{ vigenciasPlan.inicioVigenciaPaciente1 | formatoFecha }} al {{ vigenciasPlan.finVigenciaPaciente1 | formatoFecha }}</p>
                    <p class="m-0" style="color: #063553;" v-else-if="vigenciasPlan.idVigenciaSeleccionada == 2">Vigencia: {{ vigenciasPlan.inicioVigenciaPlan2 | formatoFecha }} al {{ vigenciasPlan.finVigenciaPlan2 | formatoFecha }}</p>
                </div>
            </b-col>

            <b-col
                cols="4"
                style="font-size: 16px; text-align: right; align-self: end;"
                class="pl-5 pr-0"
            >
                <span v-if="infoSaldoVale != null" style="text-align: center; padding-left: 20px">
                Saldo del vale empresarial: <span style="
                    width: 80%;
                    text-align: right;
                    font-size: 16px;
                    font-weight: bold;
                    color: var(--color-dentalia);
                    padding-right: 10px;
                    ">{{ infoSaldoVale.saldoActual | moneda }}</span>
                </span>

              <restituir-saldo-vale-paciente :info-saldo-vale="infoSaldoVale" @refreshSaldo="obtenerSaldoVale(empresaActual)"></restituir-saldo-vale-paciente>

            </b-col>
        </b-row>

        <div class="d-flex justify-content-start mt-4 mb-3 w-100">
        <div v-for="(tab, index) in tabs" v-bind:key="index">
          <div
            class="d-flex justify-content-center flex-column mr-5 pt-2"
            :class="activeTabIndex == index ? 'selected-tab' : 'default-tab'"
            @click="activeTabIndex = index"
            style="min-width: max-content"
          >
            <p
              class="m-0 text-center"
              :class="activeTabIndex == index ? '' : 'mb-2'"
            >
              {{ tab.title }}
            </p>
            <hr
              v-if="activeTabIndex == index"
              class="w-50 mx-auto m-0 p-0 mt-2"
              style="height: 0.08em; background-color: #83bee8"
            />
          </div>
        </div>
      </div>
      
      <div v-if="activeTabIndex == 0">
              <b-row>
                <b-col style="border-right: 2px solid #ececec">
                  <div
                    class="scrollable-container-catalogo no-horizontal-scroll pt-4"
                    style="min-height: 25em"
                  >
                    <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                      Descripción del plan
                    </h6>
                    <b-card-text style="text-align: left">
                      <span v-html="empresaActual.descripcion"></span>
                    </b-card-text>
                  </div>
                </b-col>
                <b-col>
                  <div
                    class="scrollable-container-catalogo no-horizontal-scroll pt-4"
                    style="min-height: 25em"
                  >
                    <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                      Requisitos
                    </h6>
                    <b-card-text style="text-align: left">
                      <span v-html="empresaActual.requisitos"></span>
                    </b-card-text>
                  </div>
                </b-col>
              </b-row>
      </div>

      <div v-if="activeTabIndex == 1">
        <b-row>
                <b-col class="pt-4" style="border-right: 1px solid #ECECEC;">
                    <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                      Tratamientos y descuentos
                    </h6>
                    <div class="scrollable-container-catalogo no-horizontal-scroll">
                      <label>Busqueda: </label>
                      <v-select
                        label="tratamiento"
                        id="idTratamiento"
                        v-model="tratamientoDescuentoBuscado"
                        :options="lstTratamientosDescuento"
                        @input="seleccionarBusquedatratamiento($event)"
                      >
                        <template #option="{ tratamiento }">
                          <label>{{ tratamiento }}</label>
                        </template>
                        <span slot="no-options">No hay datos...</span>
                      </v-select>
                      <br />
                      <b-card-text>
                        <div style="text-align: left">
                          <b-list-group class="overflow-auto" flush>
                            <b-list-group-item
                              v-for="(
                                tratamiento, index
                              ) of datosTablalstTratamientosDescuento"
                              :key="index"
                            >
                              <span v-if="tratamiento.detalleDescuento === '%'">
                                {{ tratamiento.descuento }}{{ tratamiento.detalleDescuento }} -
                              </span>
                              <span v-else>
                                {{ tratamiento.descuento | moneda }} ({{ tratamiento.detalleDescuento }}) -
                              </span>
                              {{ tratamiento.tratamiento }}
                              <strong style="font-size: 13px">
                                {{ textoDescuentoEspecialTratamiento(tratamiento) }}
                              </strong>
                            </b-list-group-item>
                          </b-list-group>
                        </div>
                        <div
                          style="text-align: center"
                          v-if="loaderTratamientos"
                        >
                          <b-spinner
                            variant="primary"
                            label="Spinning"
                          ></b-spinner>
                        </div>
                        <div style="text-align: center" v-if="blnTratamientos">
                          <b-alert show variant="warning"
                            >No se encontraron datos</b-alert
                          >
                        </div>
                      </b-card-text>
                    </div>
                </b-col>
                <b-col>
                  <div class="pt-4">
                    <h6 class="mb-3" style="color: #357D97; font-weight: 600;">
                      Grupos de tratamientos
                    </h6>
                    <div class="scrollable-container-catalogo no-horizontal-scroll">
                      <label>Busqueda: </label>
                      <v-select
                        label="nombreTratamiento"
                        id="idTratamiento"
                        v-model="tratamientoDescuentoGrupoBuscado"
                        :options="lstTratamientosDescuentoGrupo"
                        @input="seleccionarBusquedaGrupotratamiento($event)"
                      >
                        <template #option="{ nombreTratamiento }">
                          <label>{{ nombreTratamiento }}</label>
                        </template>
                        <span slot="no-options">No hay datos...</span>
                      </v-select>
                      <br />

                      <b-card-text>
                        <div style="text-align: left">
                          <b-list-group class="overflow-auto" flush>
                            <b-list-group-item
                              v-for="(
                                grupos, index
                              ) of datosTablalstTratamientosGrupoDescuento"
                              :key="index"
                            >
                              <div>
                                <span v-if="grupos.detalleDescuento === '%'">
                                {{ grupos.descuento }}{{ grupos.detalleDescuento }} -
                              </span>
                                <span v-else>
                                {{ grupos.descuento | moneda }} ({{ grupos.detalleDescuento }}) -
                              </span>
                                {{ grupos.descripcion }}
                                <strong style="font-size: 13px">
                                  {{ textoDescuentoEspecial(grupos) }}
                                </strong>
                              </div>
                              <div>Tratamientos:</div>
                              <b-list-group class="overflow-auto" flush>
                                <b-list-group-item
                                  v-for="(
                                    grupo, indice
                                  ) of grupos.tratamientoGrupoTratamientoDTOS"
                                  :key="indice"
                                >
                                  <div>
                                    Tratamiento: {{ grupo.nombreTratamiento }}
                                  </div>
                                </b-list-group-item>
                              </b-list-group>
                            </b-list-group-item>
                            <hr />
                          </b-list-group>
                        </div>
                        <div
                          style="text-align: center"
                          v-if="loaderGrupoTratamiento"
                        >
                          <b-spinner
                            variant="primary"
                            label="Spinning"
                          ></b-spinner>
                        </div>
                        <div style="text-align: center" v-if="blnGrupos">
                          <b-alert show variant="warning"
                            >No se encontraron datos</b-alert
                          >
                        </div>
                      </b-card-text>
                    </div>
                  </div>
                </b-col>
              </b-row>
      </div>

      <div v-show="activeTabIndex === 2">
         <CalculadoraPrecioTratamiento :lista-tratamientos="lstTratamientosDescuento" :lista-tratamientos-grupo="lstTratamientosDescuentoGrupo" :id-plan="Number(empresaActual.idPlan)" :es-plan-vale="infoSaldoVale != null"></CalculadoraPrecioTratamiento>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NuevoM2Service } from "@/apiServices/pti/NuevoM2Service";
import CalculadoraPrecioTratamiento from "@/views/PreciosTratamientos/CalculadoraPrecioTratamientos.vue";
import RestituirSaldoValePaciente from "@/components/saldoValePaciente/restituirSaldoValePaciente.vue";
export default {
  name: "detalle",
  components: {RestituirSaldoValePaciente, CalculadoraPrecioTratamiento},
  props: {
    vigenciasPlan: null,
    empresaActual: null,
    paciente: null,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    tabs: [
      {title: "General"},
      {title: "Tratamientos"},
      {title: "Calculadora de precios"}
    ],
    activeTabIndex: 0,
    nuevoM2Service: new NuevoM2Service(),
    blnTratamientos: false,
    blnGrupos: false,
    loaderTratamientos: false,
    loaderGrupoTratamiento: false,
    lstTratamientosDescuento: [],
    lstGruposTratamientos: [],
    datosTablalstTratamientosDescuento: [],
    datosTablalstTratamientosGrupoDescuento: [],
    tratamientoDescuentoBuscado: null,
    tratamientoDescuentoGrupoBuscado: null,
    lstTratamientosDescuentoGrupo: [],
    vale: null,
    infoSaldoVale: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.empresaActual !== null) {
      this.empresa = this.empresaActual;
      this.obtenerTratamientosDescuentos(this.empresaActual);
      this.obtenerGrupoTratamientos(this.empresaActual);
      this.obtenerSaldoVale(this.empresaActual);
    }
  },
  methods: {
    regresar() {
      this.$emit("regresar", "cerrar");
    },
    /**
     * Funcion para obtener los tratamientos descuentos
     * @param empresa
     */
    obtenerTratamientosDescuentos(empresa) {
      this.loaderTratamientos = true;
      const parametros = { idPlan: empresa.idPlan };
      this.$http
        .post(this.$api + "empresas/obtener/tratamientos/descuento", parametros)
        .then((response) => {
          this.loaderTratamientos = false;
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstTratamientosDescuento = [];
            this.datosTablalstTratamientosDescuento = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstTratamientosDescuento.push(item);
              this.datosTablalstTratamientosDescuento.push(item);
            });
          }
          if (this.lstTratamientosDescuento.length <= 0) {
            this.blnTratamientos = true;
          }
        })
        .catch(function (error) {
          this.loaderTratamientos = false;
          console.error(error);
        });
    },
    /**
     * Funcion para obtener los grupos de tratamietos
     * @param empresa
     */
    obtenerGrupoTratamientos(empresa) {
      this.loaderGrupoTratamiento = true;
      const parametros = { idPlan: empresa.idPlan };
      this.$http
        .post(this.$api + "empresas/obtener/grupos/tratamientos", parametros)
        .then((response) => {
          this.loaderGrupoTratamiento = false;
          if (response.data.data) {
            let resultado = response.data.data;
            this.lstGruposTratamientos = [];
            this.datosTablalstTratamientosGrupoDescuento = [];
            resultado.forEach((item, index) => {
              item.id = index;
              this.lstGruposTratamientos.push(item);
              this.datosTablalstTratamientosGrupoDescuento.push(item);
            });
          }
          if (this.lstGruposTratamientos.length <= 0) {
            this.blnGrupos = true;
          }
          this.buscadorSelectGrupos();
        })
        .catch(function (error) {
          this.loaderGrupoTratamiento = false;
          console.error(error);
        });
    },

    obtenerSaldoVale(empresa) {
      this.loaderGrupoTratamiento = true;
      const body = {
        idPlan : empresa.idPlan,
        idPaciente: this.paciente.idPaciente,
      }
      this.$http.post(this.$api + "vale/pacientes/movimientos/detalle", body)
        .then((r) => {
          this.loaderGrupoTratamiento = false;
          if (r != null) {
            this.infoSaldoVale = r.data.data;
          }
        })
        .catch((err) => {
          console.error(err);
          this.loaderGrupoTratamiento = false;
        });
    },

    seleccionarBusquedatratamiento(tratamiento) {
      this.datosTablalstTratamientosDescuento = [];
      if (tratamiento == null) {
        this.datosTablalstTratamientosDescuento = this.lstTratamientosDescuento;
      } else {
        this.lstTratamientosDescuento.forEach((element) => {
          if (element.idTratamiento == tratamiento.idTratamiento) {
            this.datosTablalstTratamientosDescuento.push(element);
          }
        });
      }
    },

    buscadorSelectGrupos() {
      if (this.lstGruposTratamientos.length > 0) {
        this.lstTratamientosDescuentoGrupo = [];
        this.lstGruposTratamientos.forEach((item) => {
          item.tratamientoGrupoTratamientoDTOS.forEach((datos) => {
            this.lstTratamientosDescuentoGrupo.push(datos);
          });
        });
      }
    },
    seleccionarBusquedaGrupotratamiento(tratamiento) {
      this.datosTablalstTratamientosGrupoDescuento = [];
      if (tratamiento == null) {
        this.datosTablalstTratamientosGrupoDescuento =
          this.lstGruposTratamientos;
      } else {
        this.lstGruposTratamientos.forEach((element) => {
          element.tratamientoGrupoTratamientoDTOS.forEach((datos) => {
            if (datos.idTratamiento == tratamiento.idTratamiento) {
              this.datosTablalstTratamientosGrupoDescuento.push(element);
            }
          });
        });
      }
    },
    textoDescuentoEspecial(grupos) {
      if (
          !grupos ||
          grupos.precioEspecial == null ||
          grupos.precioEspecial <= 0 ||
          !grupos.detalleDescuento
      ) {
        return '';
      }

      const veces = grupos.vecesAnio != null ? grupos.vecesAnio : 1;

      if (grupos.detalleDescuento === '%') {
        return `Descuento especial: ${grupos.precioEspecial}% (${veces} al año)`;
      }

      return `Descuento especial: ${this.$options.filters.moneda(grupos.precioEspecial)} ${grupos.detalleDescuento} (${veces} al año)`;
    },
    textoDescuentoEspecialTratamiento(tratamiento) {
      if (
          !tratamiento ||
          tratamiento.descuentoEspecial == null ||
          tratamiento.descuentoEspecial <= 0 ||
          !tratamiento.detalleDescuento
      ) {
        return '';
      }

      const veces = tratamiento.vecesAnio != null ? tratamiento.vecesAnio : 1;

      if (tratamiento.detalleDescuento === '%') {
        return `Descuento especial: ${tratamiento.descuentoEspecial}% (${veces} al año)`;
      }

      return `Descuento especial: ${this.$options.filters.moneda(tratamiento.descuentoEspecial)} ${tratamiento.detalleDescuento} (${veces} al año)`;
    },
  },
};
</script>

<style scoped>
.scrollable-container-catalogo {
  overflow-y: auto;
  max-height: 40em;
}

.selected-tab{
  font-weight: 600;
}

.default-tab{
  color: gray;
}
</style>
